import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export interface LivekitTokenRequest {
  /** LiveKit room ID for connection (entityType:entityId:onAir, e.g. Flow:flowId:onAir) */
  livekitRoomId: string;
  participantIdentity: string;
  mode?: 'preview' | 'publish';
}

export interface LivekitTokenResponse {
  token: string;
  host: string;
  roomId: string;
}

/** Fetch LiveKit token for preview (subscribe) or publish (camera/mic/screenshare). Reusable for contributors publishing as remote speakers. */
export const useLivekitTokenMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (body: LivekitTokenRequest) => {
      const token = await getToken();
      return getLivekitToken(body, token || undefined);
    },
  });
};

const getLivekitToken = async (
  body: LivekitTokenRequest,
  authToken: string | undefined,
): Promise<LivekitTokenResponse> => {
  const url = `${import.meta.env.VITE_API_URL}/player/livekit-token`;
  return sendJSONRequest({ url, method: METHOD.POST, body, token: authToken });
};
